export default __webpack_public_path__ + "static/media/img-0435-hungary-full-face.5f7a604b.png";